<template>
  <transition name="fade">
    <div
      v-if="show"
      class="fixed z-[70] flex items-center gap-2 px-4 py-3 text-sm text-white shadow-lg bottom-6 start-6 rounded-xl"
      :class="type === 'success' ? 'bg-emerald-600' : 'bg-rose-600'"
    >
      <i
        :class="type === 'success'
          ? 'mdi mdi-check-circle'
          : 'mdi mdi-alert-circle'"
        class="text-lg"
      ></i>

      <span>{{ message }}</span>

      <!-- optional close -->
      <button
        type="button"
        class="ms-2 text-white/80 hover:text-white"
        @click="$emit('update:show', false)"
      >
        <i class="text-base mdi mdi-close"></i>
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Toast",
  props: {
    show: { type: Boolean, default: false },
    type: { type: String, default: "success" }, // success | error
    message: { type: String, default: "" },
  },
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s ease, transform .2s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(6px);
}
</style>
